import React from 'react'
import PropTypes from 'prop-types'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import GalleryArray from './GalleryArray'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  textStyle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '16px',
    color: '#000000'
  },
  labelStyle: {
    fontSize: 14,
    margin: 0,
    color: '#A3A3A5',

  },
  whiteBlock: {
    margin: 0,
    padding: 0,
    marginTop:'15px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '25px'

  }
})

const defaultProps = {
  label: '',
  photos: []
}

const propTypes = {
  label: PropTypes.string,
  photos: PropTypes.array,
}

const InfoPhoto = ({ label, photos }) => {
  const classes = useStyles()

  if (photos.length === 0) {
    return null
  }

  return (
    <Row>
      <Col md={12} lg={12} xl={12} sm={12} xs={12}>
        <p className={classes.labelStyle}>{label}</p>
      </Col>
      <Col md={12} lg={12} xl={12} sm={12} xs={12} className={classes.whiteBlock}>
        <GalleryArray photos={photos}/>
      </Col>
    </Row>
  )
}

InfoPhoto.defaultProps = defaultProps
InfoPhoto.propTypes = propTypes

export default InfoPhoto



// WEBPACK FOOTER //
// ./src/App/component/ConfirmOrder/InfoPhoto.jsx